module.exports = ".schema-image{\n    width: 100%;\n}\n.schema-image.single{\n    padding: 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/schema/schema.component.css
// module id = ./src/app/schema/schema.component.css
// module chunks = main